export type LinearUnit = 'meters' | 'kilometers' | 'feet' | 'miles';
export type AreaUnit = 'square-meters' | 'square-kilometers' | 'square-feet' | 'square-miles' | 'hectares';

export function linearToEsri(u: LinearUnit | undefined): __esri.LinearUnits {
  switch (u) {
    case 'kilometers':
      return 'kilometers';
    case 'feet':
      return 'feet';
    case 'miles':
      return 'miles';
    case 'meters':
    default:
      return 'meters';
  }
}

export function areaToEsri(u: AreaUnit | undefined): __esri.AreaUnits {
  switch (u) {
    case 'square-kilometers':
      return 'square-kilometers';
    case 'square-feet':
      return 'square-feet';
    case 'square-miles':
      return 'square-miles';
    case 'hectares':
      return 'hectares';
    case 'square-meters':
    default:
      return 'square-meters';
  }
}
